import {
  ACCOUNT_TYPE_DEFINITIONS,
  ACCOUNT_TYPE_VALUES as TYPES_ACCOUNT_TYPE_VALUES,
} from '@parcel/types';
import type { EntityFilterSchema, FilterEnumValue } from '../types.js';

export const ACCOUNT_TYPE_VALUES = TYPES_ACCOUNT_TYPE_VALUES;
export const ACCOUNT_TYPE_OPTIONS: readonly FilterEnumValue[] = ACCOUNT_TYPE_DEFINITIONS;

/** Read only by the old score criterion kinds until Filters PR2; tables filter with where. */
export const accountFilters: EntityFilterSchema = {
  entity: 'account',
  fields: [
    {
      type: 'text',
      key: 'q',
      label: 'Search',
      description: 'Free-text search over account name and aliases (trigram similarity).',
    },
    {
      type: 'enum',
      key: 'account_type',
      label: 'Type',
      description: "Account classification. 'other' means the account has no classified type yet.",
      multi: true,
      values: ACCOUNT_TYPE_OPTIONS,
    },
    {
      type: 'dynamic-enum',
      key: 'city',
      label: 'City',
      description:
        'City of the account (populated by enrichment). Values come from workspace settings.',
      multi: true,
      valueSource: 'workspace-cities',
    },
    {
      type: 'date-range',
      key: 'last_activity',
      label: 'Last activity',
      description: "Date of the most recent signal on any of the account's projects.",
    },
  ],
};
